import { render, staticRenderFns } from "./service.html?vue&type=template&id=c8b0c350&scoped=true&"
import script from "./service.js?vue&type=script&lang=js&"
export * from "./service.js?vue&type=script&lang=js&"
import style0 from "./service.scss?vue&type=style&index=0&id=c8b0c350&lang=scss&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"
import style2 from "./service.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b0c350",
  null
  
)

export default component.exports